import { AfterViewInit, Component } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router"
import * as L from 'Leaflet';
import { RouteService } from '../../services/route.service';
import { MapService } from '../../services/map.service';
import { KmlService } from '../../services/kml.service';
import { MarkersService } from '../../services/markers.service';
import { StopsService } from '../../services/stops.service';

@Component({
  selector: 'app-embedded-map-trip',
  templateUrl: './embedded-map-trip.component.html',
  styleUrls: ['./embedded-map-trip.component.css']
})

export class EmbeddedMapTripComponent implements AfterViewInit {
  public map: any;
  public route_id: string;

  constructor(private routeService: RouteService, private mapService: MapService, private kmlService: KmlService, private markersService: MarkersService, private router: Router, private route: ActivatedRoute, private stopsService: StopsService) {}

  ngAfterViewInit(): void {
    this.mapService.initMap();
    if (this.mapService.map != null) {
      this.mapService.map.off();
      this.mapService.map.remove();
    }

    this.mapService.initMap();

  }
}